import React from 'react';
import { ArrowLeftIcon, SearchIcon, BellIcon, UserIcon, ChevronDownIcon, CalendarIcon, BarChart3Icon, HelpCircleIcon } from 'lucide-react';
export function Header({
  title = 'Warehouse',
  hasBackButton = true,
  hasCreateButton = true,
  createButtonText = 'Create warehouse',
  onCreateClick,
  icon = null,
  subtitle = 'Manage warehouse inventory and details'
}) {
  return <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-3345">
      <div className="px-6 py-4 flex justify-between items-center" data-id="element-3346">
        <div className="flex items-center" data-id="element-3347">
          {hasBackButton && <ArrowLeftIcon className="mr-3 text-blue-300 hover:text-white cursor-pointer transition-colors" size={20} data-id="element-3348" />}
          <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-3349">
            {icon || <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white" data-id="element-3350">
                <path d="M6 19h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z" data-id="element-3351"></path>
                <path d="M12 4v4" data-id="element-3352"></path>
                <path d="M3 10h18" data-id="element-3353"></path>
                <path d="M6 14h.01" data-id="element-3354"></path>
                <path d="M6 18h.01" data-id="element-3355"></path>
                <path d="M13 14h5" data-id="element-3356"></path>
                <path d="M13 18h5" data-id="element-3357"></path>
              </svg>}
          </div>
          <div data-id="element-3358">
            <h1 className="text-xl font-bold text-white" data-id="element-3359">{title}</h1>
            <p className="text-blue-200 text-sm hidden sm:block" data-id="element-3360">{subtitle}</p>
          </div>
        </div>
        <div className="flex items-center space-x-3" data-id="element-3361">
          <div className="relative hidden sm:block" data-id="element-3362">
            <div className="relative" data-id="element-3363">
              <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" data-id="element-3364" />
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-3365" />
            </div>
          </div>
          <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3366">
            <CalendarIcon size={20} data-id="element-3367" />
          </button>
          <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3368">
            <BarChart3Icon size={20} data-id="element-3369" />
          </button>
          <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3370">
            <HelpCircleIcon size={20} data-id="element-3371" />
          </button>
          <div className="relative" data-id="element-3372">
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-3373">
              <BellIcon size={20} data-id="element-3374" />
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-3375">
                2
              </span>
            </button>
          </div>
          <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-3376">
            <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-3377">
              <UserIcon size={16} className="text-white" data-id="element-3378" />
            </div>
            <span className="text-white text-sm font-medium hidden sm:block" data-id="element-3379">
              Daniel Alejandro
            </span>
            <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-3380" />
          </div>
          {hasCreateButton && <button onClick={onCreateClick} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-lg" data-id="element-3381">
              {createButtonText}
            </button>}
        </div>
      </div>
    </header>;
}